<template>
  <Modal
      v-model="_value"
      width="400"
      title="作废"
      @on-visible-change="visibleChange"
      ok-text="确认"
      @on-ok="onOk">
    <Form ref="jt808ServCombineOrderForm" :model="jt808ServCombineOrder">
      <FormItem prop="remark">
        <Col span="6">
          <label>备注</label>
        </Col>
        <Col span="18">
          <Input style="width: 100%;" v-model="jt808ServCombineOrder.remark"
                 type="textarea"
                 placeholder="请输入备注"></Input>
        </Col>
      </FormItem>
    </Form>
  </Modal>
</template>
<script>

  import Vue from 'vue';
  import {mapActions} from 'vuex'
  import store from '@/store'
  import {genQueryParam, genSortParam} from "@/libs/queryparamhelper"

  export default {
    name: 'jt808servcombineordercancelmodal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      initValue: null
    },
    data() {
      return {
        jt808ServCombineOrder: {
          id:null,
          remark:null
        }
      }
    },
    methods: {
      ...mapActions([
        'Jt808ServCombineOrderServ_Cancel'
      ]),
      onOk() {
        this.$Modal.confirm({
          title: '提示',
          content: '<p>确认作废</p>',
          onOk: () => {
            store.dispatch('Jt808ServCombineOrderServ_Cancel',
              {params: this.jt808ServCombineOrder}).then(() => {
              this.$Message.success('确认成功')
              this.$emit('on-success');
            }).catch(err => {
              this.$Message.error(err)
              this.$emit('on-fail');
            })
          },
          onCancel: () => {
          }
        })
      },
      visibleChange(val) {
        if(val){
          this.jt808ServCombineOrder.id = this._initValue
          this.jt808ServCombineOrder.remark = null
        }
      }
    },
    computed: {
      _value: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val)
          this.$emit('change', val)
        }
      },
      _initValue: {
        get() {
          return this.initValue
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      }
    },
    mounted() {
      this.$nextTick(() => {

      })
    }
  }
</script>
